import { render, staticRenderFns } from "./formProcessesDetails.vue?vue&type=template&id=226000ec&"
import script from "./formProcessesDetails.vue?vue&type=script&lang=js&"
export * from "./formProcessesDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports